import { CalendarCheck, MapPinned, MessagesSquare, Smartphone } from "lucide-react";
import { useLang } from "@/i18n";
import { photos } from "@/data/site";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/Reveal";
import { BookingForm } from "@/components/site/BookingForm";
import { SEO } from "@/components/site/SEO";

const ICONS = { MessagesSquare, Smartphone, MapPinned, CalendarCheck };

export default function Prenota() {
  const { t } = useLang();
  return (
    <>
      <SEO title={t.pages.prenota.seo} description={t.pages.prenota.desc} path="/prenota" />
      <PageHero image={photos.marinaPorto} eyebrow={t.pages.prenota.eyebrow} title={t.pages.prenota.title} testid="prenota-hero" />

      <section className="py-16 sm:py-24" data-testid="booking-section">
        <div className="mx-auto grid max-w-7xl items-start gap-12 px-4 sm:px-6 lg:grid-cols-5 lg:px-8">
          <Reveal className="lg:col-span-3">
            <div className="rounded-3xl border border-border bg-white p-7 shadow-sm sm:p-10">
              <h2 className="font-serif text-2xl font-semibold text-ink sm:text-3xl">{t.form.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-ink-muted sm:text-base">{t.form.subtitle}</p>
              <div className="mt-8">
                <BookingForm />
              </div>
            </div>
          </Reveal>
          <div className="lg:col-span-2">
            <Reveal delay={0.1}>
              <div className="overflow-hidden rounded-3xl border border-ochre/30 bg-gradient-to-br from-sand-deep to-stone-warm/60 p-8">
                <h3 className="font-serif text-xl font-semibold text-ink">{t.direct.title}</h3>
                <ul className="mt-5 space-y-5">
                  {t.direct.items.map((item, i) => {
                    const Icon = ICONS[item.icon];
                    return (
                      <li key={item.t} data-testid={`prenota-benefit-${i}`} className="flex gap-3.5">
                        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white text-terracotta shadow-sm">
                          <Icon size={19} />
                        </span>
                        <span>
                          <span className="block text-sm font-bold text-ink">{item.t}</span>
                          <span className="mt-0.5 block text-xs leading-relaxed text-ink-muted">{item.d}</span>
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <img src={photos.regalo} alt="Il regalo di benvenuto che ti aspetta all'arrivo" loading="lazy" className="mt-6 h-56 w-full rounded-3xl object-cover shadow-xl" />
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
